import colors from '@theme/colors'
import styled from 'styled-components'

export const MessageInput = styled.div`
  display: flex;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  align-items: center;
  :has(textarea:focus) {
    border-color: ${colors['$color-action-background-primary-hover']};
  }
  flex-shrink: 0;
`

export const StyledButton = styled.button`
  border: 1px solid transparent;
  outline: 0;
  background: none;
  font: inherit;
  border-radius: 4px;
  margin: 8px;
  cursor: pointer;
`
